'use client';

import { Box, type BoxProps } from '@ironhack/design-system2/components/box';
import { Container } from '@ironhack/design-system2/components/container';
import { Flex, type FlexProps } from '@ironhack/design-system2/components/flex';
import { forwardRef } from '@ironhack/design-system2/components/forward-ref';
import { type As, type ComponentWithAs } from '@ironhack/design-system2/types';
import { backgroundToTokens } from '@ironhack/design-system2/utils';
import { type PropsWithChildren, type ReactElement } from 'react';

import { type DatoModuleFormat } from '@/lib/datocms';
import { WRAPPER_PADDING } from './wrapper-padding';

type Props = PropsWithChildren<{
  innerProps?: FlexProps;
  moduleFormat: DatoModuleFormat;
  outerProps?: BoxProps;
}> &
  BoxProps;

export const ModuleWrapper: ComponentWithAs<As, Props> = forwardRef(
  (props: Props, ref): ReactElement => {
    const {
      children,
      innerProps,
      moduleFormat: { background, spacingBottom, spacingTop },
      outerProps,
      ...boxProps
    } = props;

    const { bg, color } = backgroundToTokens(background);
    const bottomArray = Array.isArray(spacingBottom)
      ? spacingBottom
      : [spacingBottom];
    const topArray = Array.isArray(spacingTop) ? spacingTop : [spacingTop];

    return (
      <Box
        bg={bg}
        color={color}
        pb={bottomArray.map((pad) => pad && Number.parseInt(pad) / 8)}
        pt={topArray.map((pad) => pad && Number.parseInt(pad) / 8)}
        ref={ref}
        w="full"
        {...boxProps}
        {...outerProps}
      >
        <Container display="flex" h="full" maxW="container.xl" px={0}>
          <Flex px={WRAPPER_PADDING} w="full" {...innerProps}>
            {children}
          </Flex>
        </Container>
      </Box>
    );
  }
);
